import IconButton from '@mui/material/IconButton'
import { Box } from '@material-ui/core'
import Tooltip from '@mui/material/Tooltip'

export const ZendeskPluginCTA = ({ icon, onClick, title }) => {
  return (
    <Box>
      <Tooltip title={title}>
        <IconButton
          sx={{
            width: '40px',
            height: '40px',
            marginLeft: '5px',
            backgroundColor: 'white',
            borderRadius: 0,
            border: '1px solid black',
            color: 'black',
            fontWeight: 300,
          }}
          variant="outlined"
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
